import React, { Component } from 'react';
import {
    Box,
    withStyles,
    CircularProgress,
    Typography,
} from '@material-ui/core';
import axios from 'axios';
import Swal from 'sweetalert2';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import CardSection from "../../shared/components/common/cardSection";
import CustomButton from "../../shared/components/common/customButton";
import ClienteSection from "../../shared/components/details/detailsClienteSection";
import EstimativaSection from "../../shared/components/details/detailsEstimativaSection";
import OrcamentoSection from "../../shared/components/details/detailsOrcamentoSection";
import ServiceFilesSection from "../../shared/components/details/serviceFilesSection";
import NotasFileSection from "../../shared/components/details/notasFileSection";
import QuoteBudgetFileSection from "../../shared/components/details/quoteBudgetFileSection";
import QuoteLaudoFileSection from '../../shared/components/details/quoteLaudoFileSection';
import QuoteNfFileSection from '../../shared/components/details/quoteNfFileSection';
import { ClientQuoteDetailsApi } from '../../client/clientQuoteDetails/service/clientQuoteDetailsApi';
import { AdminHomeApi } from '../adminHome/service/adminHomePageApi';
import { parseQuoteDetailsResponse } from '../../shared/utils/quoteDetailsMapper';
import { BEPI_API } from "../../shared/config/bepiApiPaths";

const ADMIN_QUOTATION_RESPONSE_URL = `${BEPI_API.admin}/home/quotations/respond`;

const styles = theme => ({
    root: {
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
        padding: '1rem'
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px'
    },
    errorContainer: {
        backgroundColor: '#dc3545',
        color: '#ffffff',
        padding: theme.spacing(2),
        borderRadius: '4px',
        textAlign: 'center',
        marginBottom: theme.spacing(2)
    }
});

class AdminDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cliente: null,
            estimativa: null,
            orcamento: null,
            sections: {
                cliente: true,
                estimativa: true,
                orcamento: true,
                serviceFiles: true
            },
            serviceFiles: [],
            rotasimplesempresa: null,
            quotationId: null,
            responseForm: {
                textoResposta: '',
                valorResposta: ''
            },
            responseSaving: false,
            responseLocked: false,
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.initDetalhes();
    }

    componentWillUnmount() {
        this.cleanupDetalhes();
    }

    getAdminIdFromUrl = () => {
        const search = window.location.search || '';
        const idFromSearch = new URLSearchParams(search).get('id');
        if (idFromSearch) return idFromSearch;

        const hash = window.location.hash || '';

        if (hash.includes('?')) {
            const queryString = hash.split('?')[1];
            return new URLSearchParams(queryString).get('id');
        }

        return null;
    };

    async initDetalhes() {
        try {
            this.setState({ loading: true, error: null });

            const quotationId = this.getAdminIdFromUrl();

            if (!quotationId) {
                const { currentLanguage } = this.props;
                throw new Error(currentLanguage ? currentLanguage.bepiService.admin.admin_details_error_no_quotation : 'Nenhuma cotação selecionada');
            }

            const response = await ClientQuoteDetailsApi.getQuoteDetails(quotationId);
            const data = parseQuoteDetailsResponse(response.data);
            const textoRespostaInicial = data?.estimativa?.texto_resposta || '';
            const valorRespostaInicial = data?.estimativa?.valor_resposta;
            const valorRespostaTexto = valorRespostaInicial === null || valorRespostaInicial === undefined
                ? ''
                : String(valorRespostaInicial);
            const respostaPreenchida = textoRespostaInicial.trim() !== '' && this.parseValorResposta(valorRespostaTexto) !== null;

            this.setState({
                quotationId,
                cliente: data.cliente,
                estimativa: data.estimativa,
                orcamento: data.orcamento,
                serviceFiles: data.serviceFiles,
                rotasimplesempresa: data.rotasimplesempresa,
                responseForm: {
                    textoResposta: textoRespostaInicial,
                    valorResposta: valorRespostaTexto
                },
                responseLocked: respostaPreenchida,
                loading: false
            });

        } catch (error) {
            console.error('Erro ao carregar detalhes:', error);
            const { currentLanguage } = this.props;
            this.setState({
                error: currentLanguage ? currentLanguage.bepiService.admin.admin_details_error_loading_details : 'Erro ao carregar detalhes.',
                loading: false
            });
        }
    }

    cleanupDetalhes() {
        this.setState({
            cliente: null,
            estimativa: null,
            orcamento: null,
            serviceFiles: [],
            rotasimplesempresa: null,
            quotationId: null,
            responseForm: {
                textoResposta: '',
                valorResposta: ''
            },
            responseSaving: false,
            responseLocked: false,
            loading: false,
            error: null
        });
    }

    toggleSection = (section) => {
        this.setState(prevState => ({
            sections: {
                ...prevState.sections,
                [section]: !prevState.sections[section]
            }
        }));
    };

    receberEquipamento = async (id) => {
        const { currentLanguage } = this.props;
        const result = await Swal.fire({
            title: currentLanguage.bepiService.admin.admin_details_swal_confirm_receive_title,
            text: currentLanguage.bepiService.admin.admin_details_swal_confirm_receive_text,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: currentLanguage.bepiService.admin.admin_details_swal_confirm_button,
            cancelButtonText: currentLanguage.bepiService.admin.admin_details_swal_cancel_button
        });

        if (!result.isConfirmed) return;

        try {
            const { estimativa } = this.state;
            const { currentLanguage } = this.props;
            const textoAnterior = estimativa?.texto_resposta || '';
            const novoTexto = (textoAnterior ? textoAnterior + '\n' : '') + currentLanguage.bepiService.admin.admin_details_status_received_analysis;

            this.setState(prevState => ({
                estimativa: {
                    ...prevState.estimativa,
                    status: 'equipamento em analise',
                    texto_resposta: novoTexto
                }
            }));

            Swal.fire(currentLanguage.bepiService.admin.admin_details_swal_success_title, currentLanguage.bepiService.admin.admin_details_swal_update_success_text, "success")
                .then(() => {
                    window.location.hash = "#lista_de_equipamentos";
                });

        } catch (err) {
            const { currentLanguage } = this.props;
            console.error('Erro ao receber equipamento:', err);
            Swal.fire(currentLanguage.bepiService.admin.admin_details_swal_error_title, currentLanguage.bepiService.admin.admin_details_swal_update_error_text, 'error');
        }
    };

    carregarOrcamento = (userId, empresa, orcamentoId, estimativaId) => {
        window.location.hash = `#orcamento?user_id=${userId}&empresa=${empresa}&orcamento_id=${orcamentoId}&estimativa_id=${estimativaId}`;
    };

    cadastrarEquipamento = () => {
        window.location.hash = '#lista_de_equipamentos';
    };

    responderEstimativa = (estimativaId) => {
        window.location.hash = `#responder_estimativa?id=${estimativaId}`;
    };

    aprovarParaManutencao = async (id) => {
        const result = await Swal.fire({
            title: 'Aprovar para Manutenção?',
            text: 'Deseja avançar este item para "Aprovado para manutenção"?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, aprovar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {
            await ClientQuoteDetailsApi.updateQuotationStatus(id, 'aprovado para manutencao');
            await this.initDetalhes();
            Swal.fire('Sucesso', 'Status atualizado para "Aprovado para manutenção".', 'success');
        } catch (error) {
            console.error('Erro ao aprovar para manutenção:', error);
            Swal.fire('Erro', 'Não foi possível atualizar o status.', 'error');
        }
    };

    marcarComoEnviado = async (id) => {
        const result = await Swal.fire({
            title: 'Marcar como Enviado?',
            text: 'Deseja avançar este item para "Enviado"?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, enviar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {
            await ClientQuoteDetailsApi.updateQuotationStatus(id, 'enviado');
            await this.initDetalhes();
            Swal.fire('Sucesso', 'Status atualizado para "Enviado".', 'success');
        } catch (error) {
            console.error('Erro ao marcar como enviado:', error);
            Swal.fire('Erro', 'Não foi possível atualizar o status.', 'error');
        }
    };

    parseValorResposta = (rawValue) => {
        if (rawValue === null || rawValue === undefined) return null;
        const normalized = String(rawValue).trim().replace(',', '.');
        if (!/^\d{1,12}(\.\d{1,2})?$/.test(normalized)) return null;
        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : null;
    };

    handleTextoRespostaChange = (event) => {
        const textoResposta = event.target.value || '';
        this.setState(prevState => ({
            responseForm: {
                ...prevState.responseForm,
                textoResposta
            }
        }));
    };

    handleValorRespostaChange = (event) => {
        const valorResposta = event.target.value || '';
        this.setState(prevState => ({
            responseForm: {
                ...prevState.responseForm,
                valorResposta
            }
        }));
    };

    enviarRespostaCliente = async () => {
        const { quotationId, responseForm } = this.state;
        const { currentLanguage } = this.props;

        const textoResposta = (responseForm.textoResposta || '').trim();
        const valorResposta = this.parseValorResposta(responseForm.valorResposta);

        if (!quotationId || !textoResposta || valorResposta === null) {
            return;
        }

        try {
            this.setState({ responseSaving: true });

            const payload = {
                id: Number(quotationId),
                textoResposta,
                valorResposta,
            };

            await axios.post(ADMIN_QUOTATION_RESPONSE_URL, payload);

            this.setState(prevState => ({
                responseSaving: false,
                responseLocked: true,
                responseForm: {
                    textoResposta,
                    valorResposta: valorResposta.toFixed(2)
                },
                estimativa: prevState.estimativa ? {
                    ...prevState.estimativa,
                    status: 'estimativa entregue',
                    texto_resposta: textoResposta,
                    valor_resposta: valorResposta
                } : prevState.estimativa
            }));

            Swal.fire(
                currentLanguage?.bepiService?.admin?.admin_details_swal_success_title || 'Sucesso',
                currentLanguage?.bepiService?.admin?.admin_details_swal_update_success_text || 'Resposta enviada com sucesso.',
                'success'
            );
        } catch (error) {
            console.error('Erro ao responder cliente:', error);
            this.setState({ responseSaving: false });
            Swal.fire(
                currentLanguage?.bepiService?.admin?.admin_details_swal_error_title || 'Erro',
                currentLanguage?.bepiService?.admin?.admin_details_swal_update_error_text || 'Não foi possível enviar a resposta.',
                'error'
            );
        }
    };

    handleFinalizarFluxo = async () => {
        const { currentLanguage } = this.props;
        const { quotationId } = this.state;

        const result = await Swal.fire({
            title: currentLanguage.bepiService.admin.admin_details_finalize_flow_confirm_title || 'Confirmar',
            text: currentLanguage.bepiService.admin.admin_details_finalize_flow_confirm_text || 'Deseja finalizar o fluxo desta cotação?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
        });

        if (!result.isConfirmed) return;

        try {
            this.setState({ loading: true });
            await AdminHomeApi.updateQuotationStatus(quotationId, 'finalizado');
            await Swal.fire(
                currentLanguage.bepiService.shared.shared_details_success_title || 'Sucesso',
                currentLanguage.bepiService.admin.admin_details_finalize_flow_success || 'Fluxo finalizado com sucesso.',
                'success'
            );
            window.location.reload();
        } catch (error) {
            console.error('Erro ao finalizar fluxo:', error);
            Swal.fire(
                currentLanguage.bepiService.shared.shared_details_error_label || 'Erro',
                error?.response?.data?.error || currentLanguage.bepiService.admin.admin_details_finalize_flow_error || 'Não foi possível finalizar o fluxo.',
                'error'
            );
        } finally {
            this.setState({ loading: false });
        }
    };

    adminAceitarOrcamento = async () => {
        const { quotationId } = this.state;
        const { currentLanguage } = this.props;

        const confirm = await Swal.fire({
            title: 'Aceitar Orçamento',
            text: 'Deseja realmente aprovar este orçamento para manutenção?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, aprovar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
        });

        if (!confirm.isConfirmed) return;

        try {
            await ClientQuoteDetailsApi.acceptBudgetByQuoteId(quotationId);
            Swal.fire('Sucesso', 'Orçamento aprovado para manutenção.', 'success').then(() => {
                window.location.reload();
            });
        } catch (error) {
            console.error('Erro ao aceitar orçamento:', error);
            Swal.fire('Erro', 'Não foi possível aprovar o orçamento.', 'error');
        }
    };

    renderContent() {
        const {
            sections,
            cliente,
            estimativa,
            orcamento,
            rotasimplesempresa,
            responseForm,
            responseSaving,
            responseLocked,
            serviceFiles,
            loading,
            error,
            quotationId
        } = this.state;
        const { classes, currentLanguage } = this.props;
        const textoResposta = (responseForm.textoResposta || '').trim();
        const valorResposta = this.parseValorResposta(responseForm.valorResposta);
        const showResponderButton = !responseLocked && !responseSaving && textoResposta !== '' && valorResposta !== null;
        const fieldsReadOnly = responseLocked || responseSaving;

        if (loading) {
            return (
                <Box className={classes.loadingContainer}>
                    <CircularProgress />
                    <Typography style={{ marginLeft: '1rem' }}>
                        {currentLanguage.bepiService.admin.admin_details_loading_text}
                    </Typography>
                </Box>
            );
        }

        if (error) {
            return (
                <Box className={classes.errorContainer}>
                    <Typography>{error}</Typography>
                </Box>
            );
        }

        return (
            <>
                <CardSection
                    title={currentLanguage.bepiService.admin.admin_details_card_title_client}
                    expanded={sections.cliente}
                    onToggle={() => this.toggleSection('cliente')}
                >
                    <ClienteSection cliente={cliente} currentLanguage={currentLanguage} />
                </CardSection>

                <CardSection
                    title={currentLanguage.bepiService.admin.admin_details_card_title_estimate}
                    expanded={sections.estimativa}
                    onToggle={() => this.toggleSection('estimativa')}
                >
                    <EstimativaSection
                        estimativa={estimativa}
                        rotasimplesempresa={rotasimplesempresa}
                        onReceberEquipamento={this.receberEquipamento}
                        onCadastrarEquipamento={this.cadastrarEquipamento}
                        onFazerApontamento={this.carregarOrcamento}
                        onApproveMaintenance={this.aprovarParaManutencao}
                        onMarkAsSent={this.marcarComoEnviado}
                        onResponderEstimativa={this.responderEstimativa}
                        onFinalizarFluxo={this.handleFinalizarFluxo}
                        adminResponseEditor={{
                            textoResposta: responseForm.textoResposta,
                            valorResposta: responseForm.valorResposta,
                            onTextoRespostaChange: this.handleTextoRespostaChange,
                            onValorRespostaChange: this.handleValorRespostaChange,
                            onEnviarResposta: this.enviarRespostaCliente,
                            showResponderButton,
                            fieldsReadOnly,
                            responseSaving
                        }}
                        modo="admin"
                    />
                </CardSection>

                <CardSection
                    title={currentLanguage.bepiService.admin.admin_details_card_title_budget}
                    expanded={sections.orcamento}
                    onToggle={() => this.toggleSection('orcamento')}
                >
                    <OrcamentoSection
                        orcamento={orcamento}
                        modo="admin"
                        quoteId={quotationId}
                        onAdminAceitarOrcamento={this.adminAceitarOrcamento}
                    />
                    <QuoteBudgetFileSection
                        quoteId={this.state.quotationId}
                        role="admin"
                        currentLanguage={currentLanguage}
                        serviceFiles={serviceFiles}
                        status={estimativa?.status}
                    />
                    <QuoteLaudoFileSection
                        quoteId={quotationId}
                        role="admin"
                        currentLanguage={currentLanguage}
                        serviceFiles={serviceFiles}
                    />
                    <QuoteNfFileSection
                        quoteId={quotationId}
                        role="admin"
                        currentLanguage={currentLanguage}
                        serviceFiles={serviceFiles}
                        status={estimativa.status}
                    />

                    {estimativa?.status?.toLowerCase() === 'pendente de aprovação' && (
                        <Box display="flex" justifyContent="center" mt={2} mb={1}>
                            <CustomButton
                                variant="greenFilled"
                                size="medium"
                                onClick={this.adminAceitarOrcamento}
                            >
                                Aceitar Orçamento
                            </CustomButton>
                        </Box>
                    )}

                </CardSection>

                <ServiceFilesSection
                    serviceFiles={serviceFiles}
                    currentLanguage={currentLanguage}
                    quoteId={this.state.quotationId}
                    role="admin"
                />
                <NotasFileSection
                    serviceFiles={serviceFiles}
                    currentLanguage={currentLanguage}
                    quoteId={this.state.quotationId}
                    role="admin"
                />
            </>
        );
    }

    render() {
        const { classes, currentLanguage } = this.props;
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/admin' },
            // { label: currentLanguage.bepiService.admin.admin_breadcrumb_quotations, path: '/bepi/admin/quotations' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_details },
        ];

        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_details}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.root}>
                    {this.renderContent()}
                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withStyles(styles)(AdminDetailsPage);
